export default "__VITE_ASSET__DOKipBOB__"